export enum CmsConnectionType {
  WordPress = 'WordPress',
  BlabberJax = 'BlabberJax',
  SquareSpace = 'SquareSpace',
  Custom = 'Custom',
  None = 'None'
}
